module.exports = __webpack_public_path__ + "static/img/crm-desc.d98b50b0.png";